import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import momentDurationFormatSetup from "moment-duration-format";

// material ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";

//- components / form
import FormSubmitButton from "../../components/form/FormSubmitButton";
import FormText from "../../components/form/FormText";
import FormTextArea from "../../components/form/FormTextArea";
import FormCheckbox from "../../components/form/FormCheckbox";
import SectionHeader from "../../components/SectionHeader";
import FormContainer from "../../components/FormContainer";
import FormDatePicker from "../../components/form/FormDatePicker";

// containers
import AuthUserContainer from "../../containers/AuthUser";
import NewsItemContainer from "../../containers/NewsItem";
import defaultContent from "./DefaultContent";
import NewsBanner from "../../components/NewsBanner";
import { add as addResource, get as getResource } from "../../modules/resource";
// no select/date pickers needed for News

momentDurationFormatSetup(moment);

// banner/type presets not used for News

const styles = () => {
  return {};
};

class SaveNews extends Component {
  constructor(props) {
    super(props);

    const newsItemId = parseInt(
      _.get(this.props, "match.params.newsItemId"),
      10
    );
    const isUpdate = !_.isNaN(newsItemId);

    this.state = {
      isUpdate,
      newsItemId,
      formFieldError: {},
      permissionMap: {},
      title: "Pearson Fuels Celebrates 450 E85 Stations Across California",
      message: defaultContent,

      dateTimeLine: moment().format("YYYY-MM-DD"),
      graphicFile: null,
      graphicPreviewUrl: "",
      graphicResourceId: null,
      uploadedResourceUrl: "",

      hasCallToAction: false,
      callToActionText: "",
      callToActionUrl: "",
    };
  }

  componentDidMount() {
    const { newsItem, getNewsItem } = this.props;
    const { newsItemId, isUpdate } = this.state;

    if (!isUpdate) {
      return;
    }

    if (newsItem) {
      this.fillForm({ newsItem });
    } else {
      getNewsItem({
        params: { newsItemIds: [newsItemId] },
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { newsItem } = this.props;
    if (_.isUndefined(prevProps.newsItem) && !_.isUndefined(newsItem)) {
      this.fillForm({ newsItem });
    }
  }

  fillForm = ({ newsItem }) => {
    if (!newsItem) {
      return;
    }

    const newState = {};
    ["title", "message", "graphicResourceId", "callToActionText", "callToActionUrl", "hasCallToAction"].forEach((key) => {
      if (_.isNil(newsItem[key])) {
        return;
      }
      newState[key] = newsItem[key];
    });

    // If older items don't have a boolean flag, infer from values.
    if (_.isUndefined(newState.hasCallToAction)) {
      const hasAnyCta =
        !!(newState.callToActionText && String(newState.callToActionText).trim()) ||
        !!(newState.callToActionUrl && String(newState.callToActionUrl).trim());
      newState.hasCallToAction = hasAnyCta;
    }

    // Prefer startDate for the date picker; fallback to parsing dateTimeLine; else today
    let dateForPicker = "";
    if (newsItem.startDate) {
      dateForPicker = moment(newsItem.startDate).format("YYYY-MM-DD");
    } else if (newsItem.dateTimeLine) {
      const m = moment(
        newsItem.dateTimeLine,
        ["YYYY-MM-DD", "dddd, MMMM Do", "MMM Do, YYYY"],
        true
      );
      dateForPicker = m.isValid()
        ? m.format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    } else {
      dateForPicker = moment().format("YYYY-MM-DD");
    }
    newState.dateTimeLine = dateForPicker;

    this.setState(newState, () => {
      const { graphicResourceId } = this.state;
      if (!graphicResourceId) {
        return;
      }
      this.loadResourceUrl(graphicResourceId);
    });
  };

  onChange = (value, path) => {
    const arrayPath = _.toPath(path);
    const basePath = _.head(arrayPath);
    let base = this.state[basePath];
    let newState = {};

    if (_.isArray(base) || _.isObject(base)) {
      base = _.cloneDeep(base);
      _.set(base, arrayPath.slice(1), value);
      newState[basePath] = base;
    } else {
      newState[basePath] = value;
    }

    let formFieldError = Object.assign({}, this.state.formFieldError);
    delete formFieldError[path];
    newState.formFieldError = formFieldError;

    this.setState(newState);
  };

  onGraphicChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      this.setState({
        graphicFile: null,
        graphicPreviewUrl: "",
        graphicResourceId: null,
        uploadedResourceUrl: "",
      });
      return;
    }
    const previewUrl = URL.createObjectURL(file);
    this.setState({ graphicFile: file, graphicPreviewUrl: previewUrl });

    // Upload to resource.add
    this.props.addResource({
      params: {},
      files: [{ name: "file", data: file }],
      callback: (err, result) => {
        if (err) {
          return; // errors surfaced globally already
        }
        const resourceId = _.get(result, ["resourceIds", 0]);
        const collection = _.get(
          result,
          ["collections", "resourceCollection"],
          []
        );
        const resourceObj =
          _.find(collection, { resourceId }) || _.head(collection) || {};
        const resourceUrl = resourceObj.url || "";
        this.setState({
          graphicResourceId: resourceId || null,
          uploadedResourceUrl: resourceUrl,
        });
      },
    });
  };

  loadResourceUrl = (resourceId) => {
    const { resourceMap } = this.props;
    const existing = resourceId && resourceMap ? resourceMap[resourceId] : null;
    if (existing && existing.url) {
      this.setState({
        uploadedResourceUrl: existing.url,
        graphicPreviewUrl: existing.url,
      });
      return;
    }
    if (!resourceId) {
      return;
    }
    this.props.getResource({
      params: { resourceIds: [resourceId] },
      callback: (err, result) => {
        if (err) {
          return;
        }
        const collection = _.get(
          result,
          ["collections", "resourceCollection"],
          []
        );
        const found =
          _.find(collection, { resourceId }) || _.head(collection) || {};
        if (found.url) {
          this.setState({
            uploadedResourceUrl: found.url,
            graphicPreviewUrl: found.url,
          });
        }
      },
    });
  };

  clearContent = () => {
    this.setState({ message: "" });
  };

  handleSave = () => {
    const { addNewsItem, updateNewsItem, showErrors } = this.props;
    const { isUpdate, newsItemId } = this.state;

    const formFieldError = {};

    const requiredFields = [
      { path: "title", label: "Title" },
      { path: "message", label: "Article Content" },
      { path: "dateTimeLine", label: "Date / time line" },
    ];

    requiredFields.forEach(({ path, label }) => {
      if (!this.state[path]) {
        formFieldError[path] = `${label} is required`;
      }
    });

    const hasCallToAction = !!this.state.hasCallToAction;
    if (hasCallToAction) {
      if (!String(this.state.callToActionText || "").trim()) {
        formFieldError.callToActionText = "Call to Action button text is required";
      }
      if (!String(this.state.callToActionUrl || "").trim()) {
        formFieldError.callToActionUrl = "Call to Action URL is required";
      }
    }

    if (_.keys(formFieldError).length) {
      this.setState({ formFieldError });
      showErrors(_.values(formFieldError));
      return;
    }

    const {
      title,
      message,
      dateTimeLine,
      graphicResourceId,
      callToActionText,
      callToActionUrl,
    } = this.state;

    const params = {
      title,
      message,
      dateTimeLine: moment(dateTimeLine).format("MMMM Do, YYYY"),
      // required by API per request
      type: "news",
      startDate: dateTimeLine,
      bannerColor: "#f5a41d",
      bannerTagline: "News",
      hasCallToAction,
    };

    if (graphicResourceId) {
      params.graphicResourceId = graphicResourceId;
    }

    if (hasCallToAction) {
      params.callToActionText = callToActionText;
      params.callToActionUrl = callToActionUrl;
    } else {
      // Explicitly clear when toggled off (if API supports these fields).
      params.callToActionText = null;
      params.callToActionUrl = null;
    }

    this.setState({
      isSavingOpen: true,
      savingStatus: "saving",
    });

    if (!isUpdate) {
      addNewsItem({
        params,
      });
    } else {
      params.newsItemId = newsItemId;
      updateNewsItem({
        params,
      });
    }
  };

  getInputProps = (path, defaultValue) => {
    return {
      key: path,
      path,
      value: this.getValue(path, defaultValue),
      checked: this.getValue(path, defaultValue),
      error: this.getError(path),
      onChange: this.onChange,
      gridProps: { md: 12 },
    };
  };

  getValue = (path, defaultValue) => {
    const _d = _.isUndefined(defaultValue) ? "" : defaultValue;
    return _.get(this.state, path, _d);
  };

  getError = (path) => {
    return _.get(this.state.formFieldError, path);
  };

  render() {
    const {
      isUpdate,
      title,
      // message,
      dateTimeLine,
      graphicPreviewUrl,
      uploadedResourceUrl,
      hasCallToAction,
    } = this.state;

    const bannerColor = "#f5a41d";
    const bannerTagline = "News";
    const bannerResourceUrl = uploadedResourceUrl || graphicPreviewUrl || "";

    const action = isUpdate ? "Update" : "Add";
    return (
      <FormContainer headline={`${action} News Item`}>
        <SectionHeader label="Messaging" gridProps={{ md: 12 }} />

        <FormText {...this.getInputProps("title")} label={"Title"} />

        <FormDatePicker
          {...this.getInputProps("dateTimeLine")}
          label={"Date"}
          helpText={"Displayed date on the card"}
        />

        <SectionHeader label="Card Graphic" gridProps={{ md: 12 }} />
        <Grid item md={12}>
          <input
            type="file"
            accept="image/*"
            onChange={this.onGraphicChange}
            style={{ marginBottom: 16 }}
          />
        </Grid>

        {/* Info section removed for News */}

        <SectionHeader label="Sample Preview" gridProps={{ md: 12 }} />
        <Grid item md={12}>
          <div style={{ paddingBottom: 20, fontWeight: 300, color: "#333" }}>
            (note : sizes and fonts vary based on mobile device)
          </div>

          <NewsBanner
            title={title}
            dateTimeLine={
              dateTimeLine ? moment(dateTimeLine).format("MMMM Do, YYYY") : ""
            }
            bannerColor={bannerColor}
            bannerTagline={bannerTagline}
            resourceUrl={bannerResourceUrl}
          />
        </Grid>

        <Grid
          item
          md={12}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            variant="outlined"
            size="small"
            onClick={this.clearContent}
            style={{ marginBottom: -20 }}
          >
            Clear
          </Button>
        </Grid>

        <FormTextArea
          {...this.getInputProps("message")}
          label={"Article Content"}
          rows={20}
        />

        <FormCheckbox
          {...this.getInputProps("hasCallToAction", false)}
          label={"Add a Call To action to this article"}
          gridProps={{ md: 12 }}
        />

        <FormText
          {...this.getInputProps("callToActionText")}
          label={"Call To Action button text"}
          disabled={!hasCallToAction}
        />

        <FormText
          {...this.getInputProps("callToActionUrl")}
          label={"Call To Action URL"}
          disabled={!hasCallToAction}
          helpText={"Example: https://example.com"}
        />

        <FormSubmitButton
          onClick={this.handleSave}
          buttonText={`${action} News Item`}
        />
      </FormContainer>
    );
  }
}

SaveNews.propTypes = {
  addNewsItem: PropTypes.func.isRequired,
  updateNewsItem: PropTypes.func.isRequired,
  newsItem: PropTypes.object,
  showErrors: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default _.flow([
  withStyles(styles),
  AuthUserContainer,
  NewsItemContainer,
  connect(
    (state) => ({
      resourceMap: _.get(state, ["maps", "resource"], {}),
    }),
    { addResource, getResource }
  ),
])(SaveNews);
